import base from './classes'
import cloneDeep from 'src/utils/objectOperations/cloneDeep'

const derived = cloneDeep(base)

derived.getters.columns = (state, getters, rootState) => {
  const cols = base.getters.columns(state, getters, rootState)
  cols.find(col => col.name === 'capacity').hideWhenDisplaying = false
  return cols
}

export default derived
